export default __webpack_public_path__ + "static/media/main_picture_3.e7d5ac3f.svg";